import { apiFetch } from "@/api/client";

export interface DashboardSummary {
  online_users: number;
  active_sessions: number;
  logins_today: number;
  failed_logins_today: number;
}

export interface SystemHealth {
  cpu_percent: number;
  memory_percent: number;
  memory_used_gb: number;
  memory_total_gb: number;
  disk_percent: number;
  disk_used_gb: number;
  disk_total_gb: number;
  load_average: number[];
}

export const fetchDashboardSummary = () => apiFetch<DashboardSummary>("/dashboard/summary");
export const fetchSystemHealth = () => apiFetch<SystemHealth>("/dashboard/system-health");
